"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processQuestion = void 0;
/* eslint-disable sonarjs/cognitive-complexity */
const yup_database_adapter_1 = require("@visto-tech/yup-database-adapter");
const create_ordinal_1 = require("./create-ordinal");
const createCondition_1 = require("./createCondition");
const process_scope_1 = require("./process-scope");
const processQuestion = ({ question, ordinal, ordinalIncremeneter, conditions, formId, ordinals, value, scopeEntityId, }) => {
    var _a, _b, _c;
    if (question.title || question.subtitle) {
        return null;
    }
    const labelValue = question.label || makeid(10);
    ordinal(question);
    handleRenderIf(question, conditions, { value, scopeEntityId }, formId);
    let validationRules = (0, yup_database_adapter_1.serialize)((yup) => yup.string().required("Please fill in the above question."));
    if (question.validationRules) {
        validationRules = question.validationRules;
    }
    else if (question.validationRules === null ||
        question.inputType === "HEADING") {
        validationRules = undefined;
    }
    const processedQuestion = {
        create: {
            // id: question.id || getNextQuestionId(),
            label: labelValue,
            question: question.question,
            layout: question.layout,
            tip: (_a = question === null || question === void 0 ? void 0 : question.tip) !== null && _a !== void 0 ? _a : undefined,
            validationRules,
            questionOptions: ((_b = question === null || question === void 0 ? void 0 : question.options) === null || _b === void 0 ? void 0 : _b.length)
                ? {
                    connectOrCreate: ((_c = question.options) === null || _c === void 0 ? void 0 : _c.map((option) => {
                        return {
                            create: typeof option === "string" ? { option: option } : option,
                            where: typeof option === "string"
                                ? { option: option }
                                : { option: option.option },
                        };
                    })) || [],
                }
                : undefined,
            inputType: question.inputType,
        },
        where: {
            label: labelValue,
        },
    };
    if (!question.dependantQuestions)
        return processedQuestion;
    return [
        processedQuestion,
        ...question.dependantQuestions.flatMap((q) => {
            handleRenderIf(q, conditions, { value, scopeEntityId }, formId);
            return (0, exports.processQuestion)({
                question: q,
                ordinal: () => (0, create_ordinal_1.createOrdinal)(q, ordinalIncremeneter(), (0, process_scope_1.processScope)(value, scopeEntityId), ordinals),
                ordinalIncremeneter,
                conditions,
                ordinals,
                value,
                scopeEntityId,
            });
        }),
    ];
};
exports.processQuestion = processQuestion;
function handleRenderIf(q, conditions, ordinalValue, formId) {
    if (q.renderIf && q.renderIf.length) {
        q.renderIf.forEach((condition) => {
            (0, createCondition_1.createCondition)(conditions, (0, process_scope_1.processScope)(condition[3] || ordinalValue.value, condition[3] ? formId : ordinalValue.scopeEntityId), q.label, ...condition);
        });
    }
}
function makeid(length) {
    let result = "";
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}
